import { ArrowRight, Play } from 'lucide-react'
import LandingOrb from './LandingOrb'
import type { LandingPersona } from '@/hooks/useLandingPersona'

interface Props {
  persona: LandingPersona
  onPrimary: () => void
  onSecondary: () => void
  swipe?: {
    onTouchStart: (e: React.TouchEvent) => void
    onTouchEnd: (e: React.TouchEvent) => void
  }
}

export default function LandingHero({ persona, onPrimary, onSecondary, swipe }: Props) {
  // Split headline so first word gets the accent color
  const words = persona.headline.split(' ')
  const firstWord = words[0]
  const rest = words.slice(1).join(' ')

  return (
    <section className="lp-hero" id="top" {...(swipe ?? {})}>
      <div className="lp-container lp-hero-grid">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
          <span className="lp-badge lp-reveal" data-delay="1">
            <span className="dot" /> {persona.eyebrow}
          </span>

          <h1 className="lp-hero-headline lp-reveal" data-delay="2">
            <span>{firstWord}</span> {rest}
          </h1>

          <p className="lp-hero-sub lp-reveal" data-delay="3">
            {persona.subheadline}
          </p>

          <p className="lp-hero-accent lp-reveal" data-delay="3">
            {persona.accentText}
          </p>

          <div
            className="lp-reveal"
            data-delay="4"
            style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 8 }}
          >
            <button className="lp-btn-primary" onClick={onPrimary}>
              {persona.cta} <ArrowRight size={16} />
            </button>
            <button className="lp-btn-outline" onClick={onSecondary}>
              <Play size={14} /> See it in action
            </button>
          </div>

          <div className="lp-hero-stats lp-reveal" data-delay="4">
            {persona.metrics.map((m) => (
              <div key={m.label}>
                <div className="lp-stat-value">{m.value}</div>
                <div className="lp-stat-label">{m.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lp-orb-wrap lp-reveal" data-delay="2">
          <div className="lp-orb-halo" />
          <LandingOrb
            personaId={persona.id}
            primary={persona.primary}
            secondary={persona.secondary}
            glow={persona.glow}
            shape={persona.orbShape}
            radiusScale={persona.orbRadiusScale}
            rings={persona.rings}
            nodeCount={persona.nodeCount}
            size={500}
            interaction={persona.interaction}
            interactive
          />
        </div>
      </div>
    </section>
  )
}
